<template>
  <footer  ref="footerNode" :style="styleCss">
    <div class="flex-center footer-main "  >
      <div class="logo">
        <img src="@/assets/img/icon_logo.png" alt="logo">
      </div>
      <img src="@/assets/img/line.png" alt="line" class="line">
      <div class="footer">
        <p>Copyright@2007 - 现在 BAIINFO.COM Inc. All Rights Reserved. 百川盈孚 版权所有   </p>
        <p>地址：北京市东城区东直门外大街39号院2号楼航空服务楼5层501A  邮编：100028 </p>
        <p>联系人：熊文国   电话：010-59795659   010-52593666 手机：18618300427 Email：xwg@baiinfo.com</p>
      </div>
    </div>
    <div class="flex-center footer-bottom">
      <img src="@/assets/img/guohui.png">
      <span >
          <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010102006027" target="_blank">京公网安备11010102006027号</a>
      </span>
      <span> 京B2-20191023</span>
      <span><a href="https://beian.miit.gov.cn" target="_blank">京ICP备19003235号 </a></span>
    </div>
  </footer>
</template>

<script>
import { defineComponent, ref, onMounted, onUnmounted, reactive, nextTick } from "vue"

export default defineComponent({
  setup() {
    const footerNode = ref(null)
    const styleCss = reactive({})

    const isScroll = () => {
      let height = document.querySelector("#app > main").clientHeight
      let scrollHeight = document.documentElement.scrollHeight
      let footerNodeHeight = footerNode.value.offsetHeight
      return scrollHeight > height + footerNodeHeight
    }

    const updateStyleCss = () => {
      nextTick(() => {
        if (!isScroll()) {
          styleCss.position = "static"
        } else {
          styleCss.position = "fixed"
          styleCss.left = 0
          styleCss.right = 0
          styleCss.bottom = 0
        }
      })
    }

    let resizeObserver
    onMounted(() => {
      resizeObserver = new ResizeObserver(() => {
        updateStyleCss()
      })

      resizeObserver.observe(document.documentElement)
    })

    onUnmounted(() => {
      if (resizeObserver) {
        resizeObserver.disconnect()
        resizeObserver = null
      }
    })

    return {
      footerNode,
      styleCss,
    }
  }
})
</script>

<style lang="scss" scoped>
footer {
  height: 160px;
  background: #2A2A2C;

  .footer-main{
    height: 130px;
  }
  .footer-bottom{
    height: 30px;
    line-height: 30px;
    background-color: #000000;
    color: rgba(255, 255, 255, 0.7);
    a,span{
      padding-left: 1rem;
      font-size: 12px;
      color: rgba(255, 255, 255, 0.7);
    }

  }
  .logo img {
    width: 109px;
    height: 44px;
  }
  .line {
    width: 1px;
    height: 56px;
    margin: 0 41px;
  }
  .footer {
    p {
      font-size: 12px;
      color: rgba(255, 255, 255, 0.7);
      margin-bottom: 10px;

      &:last-of-type{
        margin-bottom: 0;
      }
    }
    
  }
}
@media screen and (max-width: 750px) {
  footer {
    height: 300px;
    padding: 0 20px;
    flex-direction: column;
    .line {
      margin: 0;
      transform: rotate(90deg);
    }
  }
}
</style>